import React from "react"
import PropTypes from "prop-types"

import { css } from "@emotion/react"
import { rgba } from "polished"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import useMixins, { fontSize, globalColors } from "../css-functions"
import { ln2Span } from "../util-functions"
import JSONData from "../../../content/classes.json"

const LearnClasses = ({
  pcTitle,
}) => {
  const bp = useBreakpoint()
  const mixins = useMixins()

  const style = {
    section: css`
      ${mixins.default.sectionStyle}
    `,
    title: css`
      ${mixins.default.generalTitleStyle}
    `,
    listWrapper: css`
      ${mixins.default.contentStyle}
    `,
    listItem: css`
      &:not(:first-of-type) {
        margin-top: 20px;
      }
    `,
    checkbox: css`
      display: none;
      &:checked {
        & ~ .areaLabel {
          &::after {
            transform: translateY(-30%) rotate(225deg);
          }
        }
        & ~ .areaBody {
          padding: 0 20px 20px 20px;
          height: auto;
        }
      }
    `,
    area: css`
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${globalColors.lightgray};
      position: relative;
      cursor: pointer;
      ${bp.isTablet ? fontSize(20) : fontSize(16)}
      &::after {
        width: 12px;
        height: 12px;
        content: "";
        display: block;
        border-right: 1px solid ${globalColors.gray};
        border-bottom: 1px solid ${globalColors.gray};
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-70%) rotate(45deg);
        transition: transform 0.2s ease-in-out;
      }
    `,
    body: css`
      padding: 0 20px;
      height: 0;
      overflow: hidden;
      background-color: ${globalColors.lightgray};
      transition: padding 0.2s ease;
    `,
    detailWrapper: css`
      padding-top: 40px;
      position: relative;
      &::after {
        width: 4px;
        height: 8px;
        content: "";
        display: block;
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${globalColors.gold};
      }
    `,
    detailListWrapper: css`
    `,
    detailList: css`
      display: grid;
      grid-template-columns: max-content auto;
      column-gap: 32px;
      row-gap: 12px;
    `,
    detailListTitle: css`
      position: relative;
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
      font-family: "Noto Sans JP";
      line-height: 2;
      &::after {
        width: 3px;
        height: 3px;
        content: "";
        display: block;
        background-color: ${rgba(globalColors.gray, 0.3)};
        position: absolute;
        top: ${bp.isTablet ? '12px' : '9px'};
        right: -20px;
        border-radius: 50%;
      }
    `,
    detailListData: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      ${bp.isTablet ? fontSize(16) : fontSize(13)}
      line-height: 1.8;
      &.classNameData {
        font-weight: 700;
      }
    `,
    detailOption: css`
      margin-top: ${ bp.isTablet ? '40px' : '16px' };
    `,
    detailOptionLink: css`
      ${ mixins.default.goDetailButtonStyle }
    `,
  }

  return (
    <>
      { pcTitle }
      {JSONData.classes.map((section) => {
        return (
          <section
            key={section.class}
            css={style.section}
          >
            <h2 css={style.title}>{section.class}</h2>
            <div css={style.listWrapper}>
              <ul>
                {section.area.map((block) => {
                  return (
                    <li
                      key={block.location}
                      css={style.listItem}
                    >
                      <input
                        id={block.id}
                        type="checkbox"
                        role="button"
                        aria-label="toggle detail"
                        css={style.checkbox}
                      />
                      <label
                        htmlFor={block.id}
                        className="areaLabel"
                        css={style.area}
                      >
                        {block.location}
                      </label>
                      <div
                        className="areaBody"
                        css={style.body}
                      >
                        {block.detail.map((element) => {
                          return (
                            <div
                              key={element.place}
                              css={style.detailWrapper}
                            >
                              <div
                                css={style.detailListWrapper}
                              >
                                <dl css={style.detailList}>
                                  <dt css={style.detailListTitle}>教　室</dt>
                                  <dd
                                    css={style.detailListData}
                                    className="classNameData"
                                  >{ln2Span(element.place)}</dd>
                                  <dt css={style.detailListTitle}>所在地</dt>
                                  <dd css={style.detailListData}>{ln2Span(element.info)}</dd>
                                  <dt css={style.detailListTitle}>稽古日</dt>
                                  <dd css={style.detailListData}>{ln2Span(element.open)}</dd>
                                </dl>
                              </div>
                              {element.buttonlink ? (
                                <div
                                  css={style.detailOption}
                                >
                                  <a
                                    href={element.buttonlink.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    css={style.detailOptionLink}
                                  >
                                    {element.buttonlink.text}
                                  </a>
                                </div>
                              ) : ""}
                            </div>
                          )
                        })}
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </section>
        )
      })}
    </>
  )
}

LearnClasses.propTypes = {
  pcTitle: PropTypes.object,
}

export default LearnClasses